import api from 'api/apiInstance';

export function userActivateApi(path: string) {
  return {
    path,
    PATCH: () => api.patch(path),
  };
}
